import { useContext } from 'react';
import { DropdownItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCancel } from '@fortawesome/free-solid-svg-icons';
import { DispatchContext } from '../../../DispatchContext';
import { useCancelJob } from './useCancelJob.hook';

export const CancelJob = ({ day, ...job }) => {
    const { jobCancellationTypes, jobCancellationReasons } = useContext(DispatchContext);

    const handleRemoveDayJob = useCancelJob({
        day, job, jobCancellationTypes, jobCancellationReasons,
    });

    return (
        <DropdownItem
            className="text-danger"
            onClick={handleRemoveDayJob}
        >
            <FontAwesomeIcon icon={faCancel} />
            <span>Cancel Job</span>
        </DropdownItem>
    );
};